export default __webpack_public_path__ + "static/media/loading_logo_color.0b2b0877.gif";